import { Router } from '@angular/router';
import { Session } from '../session/session.service';
import { AuthenticationService } from './auth.service';
import { Injectable, NgZone } from '@angular/core';

const MINUTES_UNITL_AUTO_LOGOUT = 30 // in Minutes
const CHECK_INTERVALL = 1000 // in ms
const STORE_KEY = 'lastAction';

@Injectable()
export class AutoLogoutService {

  constructor(
    private auth: AuthenticationService,
    private session: Session,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.check();
    this.initListener();
    this.initInterval();
  }

  get lastAction() {
    return parseInt(sessionStorage.getItem(STORE_KEY));
  }
  set lastAction(value) {
    sessionStorage.setItem(STORE_KEY, value+"");
  }

  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
    });
  }

  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.check();
      }, CHECK_INTERVALL);
    })
  }

  reset() {
    this.lastAction = Date.now();
  }

  check() {
    const now = Date.now();
    const timeleft = this.lastAction + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    this.ngZone.run(() => {
      if (isTimeout && this.session.loggedIn) {
        console.log(`La sesion se ha cerrado luego de ${MINUTES_UNITL_AUTO_LOGOUT} minutos de inactvidad.`);
        this.auth.logout(()=>{});
        this.router.navigateByUrl("pages/login");
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth/authlogout.service.ts